{
	"title": "Musíte se přihlásit",
	"description": "Pro zobrazení této stránky je nutné být přihlášen. Prosím přihlaste se. Poté budete přesměrováni na požadovanou stránku.",
	"primaryButtonTitle": "Otevřete přihlášení"
}
